import React, { useEffect, useState } from "react";
import { calcularEdad, fechaActual } from "../../../hooks/UseDate";
import { getObtenerTodasOpcionesCirugia, postIPInformacion, postIPQuirofanos, postIPTodosCirugias } from "../../../services/PaginaRuta";
//import {PDFDownloadLink} from '@react-pdf/renderer'
//import ConsentimientoPDF from "../../../pages/ConsentimientoPDF";
import * as XLSX from 'xlsx';
import ModalConfirmarProgramacionCirugiasPDF from "./ModalConfirmarProgramacionCirugiasPDF";
import config from "../../../config";

const ImprimirProgramacion = ({ setmodalOnImprimirProgramacion }) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [dataQuirofanos, setdataQuirofanos]=useState([])
  //const [textEdit, settextEdit]=useState('PRUEBAS \n 900612531 \n PROGRAMACION DIARIA DE CIRUGIAS \n\n\n')
  const [modalOnDescargarProgramcionCirugia, setmodalOnDescargarProgramcionCirugia]=useState(false)
  const [erroDate, setError] =useState('Ingresar Fecha')
  const [dataProgramacionCirugia, setdataProgramacionCirugia]=useState([])
  const [fechaInicial, setfechaInicial]=useState('')
  const [fechaFinal, setfechaFinal]=useState('')
  const [dataOpcionCirugia, setdataOpcionCirugia]=useState([])
  const handleCancelarClick = () => {
    setmodalOnImprimirProgramacion(false);
    
  };


  const handleonchangeConfirmar = (e) => {
    e.preventDefault()
   
    setfechaInicial(e.target.fechaInicio.value)
    setfechaFinal(e.target.fechaFinal.value)
    setError('');
    const fecha = new Date(e.target.value);
    
    // Ajustamos la fecha para evitar problemas con la zona horaria
    fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
    
    //const year = fecha.getFullYear();
    //const month = ('0' + (fecha.getMonth() + 1)).slice(-2);
    //const day = ('0' + fecha.getDate()).slice(-2);
  
    //const fechaHoraActualFormadoAADDMM = `${year}-${month}-${day}`;
    

    const infoProgramacion={
      "ProFec":e.target.fechaInicio.value,
      "ProFecF":e.target.fechaFinal.value,
      "ProCons":e.target.quirofano.value,
      "ProSit":e.target.tipoAtencion.value,
      "ClaPro":"", //clase procedimiento,
      "ProEsta": e.target.estado.value
    }
    postIPInformacion(infoProgramacion).then((res)=>{
      console.log(res.data,'imprimirrr')
      setdataProgramacionCirugia(Object.values(res.data));
      exportToExcell(Object.values(res.data))
      //setmodalOnDescargarProgramcionCirugia(true)
    }).catch(error => {
      
      
    });
  
   
  };

  // const handleClickConfirmar=()=>{ 
  //   setmodalOnDescargarProgramcionCirugia(true)
  // }
  

   useEffect(()=>{
  
    //console.log(textIm,'text')
    const quirofanosIp={
      MCDpto:usuarioInfo.Sede,
      ConsTpo:'QR'
    }
    postIPQuirofanos(quirofanosIp).then((res)=>{
      //console.log(Object.values(res.data),'data quirofanos')
      setdataQuirofanos(res.data)
    }).catch(error => {
      
      
    });


    getObtenerTodasOpcionesCirugia().then((res)=>{ 
      console.log(res.data.data)
      setdataOpcionCirugia(res.data.data)
    })
  
  },[])

  

  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Programación diaria de Cirugias
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          
          <div className="flex-auto overflow-y-auto relative p-2">
          <form onSubmit={handleonchangeConfirmar}>
          <div className="flex-auto overflow-y-auto relative p-2">
            {/* <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Sede
                </label>
                <div className="w-2/3 ">
                  <select
                    disabled={true}
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option>Pruebas Ospedale</option>
                    
                  </select>
                </div>
              </div>
            </div> */}
            <div className="flex  text-left w-2/4">
              <div className="  xl:w-96 px-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Fecha Programación Inicio
                </label>
                <div className="flex">
                  <input
                    //onChange={handleonchangeConfirmar}
                    defaultValue={fechaActual()}
                    name="fechaInicio"
                    type="date"
                    className="form-control  block w-full  px-3 py-1.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div className="flex  text-left w-2/4">
              <div className="  xl:w-96 px-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label inline-block mb-2 text-gray-900 font-medium"
                >
                  Fecha Programación Final
                </label>
                <div className="flex">
                  <input
                   //onChange={handleOnsubmit}
                    defaultValue={fechaActual()}
                    name="fechaFinal"
                    type="date"
                    className="form-control  block w-full  px-3 py-1.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Quirófano
                </label>
                <div className="w-2/3 ">
                  <select
                  name="quirofano"
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option value=''>Todos los quirófanos</option>
                    {
                      dataQuirofanos.map((item)=>(
                        <option value={item.ConsCod} key={item.ConsCod}>{item.ConsDet}</option>
                      ))
                      
                    }
                    
                  </select>
                </div>
              </div>
            </div>
            <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo de Atención
                </label>
                <div className="w-2/3 ">
                  <select
                    name="tipoAtencion"
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option value=''>Todos</option>
                    {
                                          dataOpcionCirugia.map((item)=>(
                                            <option value={item.PrcMulOpc} key={item.PrcMulOpc}>{item.PrcMulDsc}</option>
                                          ))
                                        }
                    
                    
                  </select>
                </div>
              </div>
            </div>
            <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Estado
                </label>
                <div className="w-2/3 ">
                  <select
                    name="estado"
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option value=''>Todos</option>
                    <option value='6'>Pendiente</option>
                    <option value='1'>Reservado</option>
                    <option value='2'>confirmado</option>
                    <option value='ingreso a sala'>Ingreso a sala</option>
                    <option value='preparado'>Preparado</option>
                    <option value='cirugia'>Cirugia</option>
                    <option value='recuperacion'>Recuperacion</option>
                    <option value='4'>Realizada</option>
                    <option value='salida'>Salida</option>
                    <option value='5'>Facturado </option>
                  </select>
                </div>
              </div>
            </div>
            {/* <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo Reporte
                </label>
                <div className="w-2/3 ">
                  <select
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option>Tipo uno</option>
                    <option>Tipo Dos</option>

                    
                  </select>
                </div>
              </div>
            </div> */}
            {/* <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo de Detalle
                </label>
                <div className="w-2/3 ">
                  <select
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option>Detallado</option>
                    <option>Consolidado</option>

                    
                  </select>
                </div>
              </div>
            </div> */}
            {/* <div className="flex  text-left">
              <div className="w-2/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Salida Reporte
                </label>
                <div className="w-2/3 ">
                  <select
                    className="form-select block  w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                  >
                    <option>En pantalla</option>
                    <option>En impresora</option>
                    <option>En excel</option>
                    
                  </select>
                </div>
              </div>
            </div> */}
          </div>
          
          
          
          
          
          
          

          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-3 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            {/* <PDFDownloadLink document={<ConsentimientoPDF informacion={textEdit}/>} fileName="programacioncirugiass.pdf"> */}
            {/* <button 
              type="submit"
               //onClick={handleClickConfirmar}
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button> */}
            <button 
              type="submit"
              // onClick={()=>exportToExcell()}
              className="inline-block px-3 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-[#9e56fe] hover:shadow-lg focus:bg-[#9e56fe] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-[#9e56fe] active:shadow-lg transition duration-150 ease-in-out ml-1">
              Exportar a PDF
            </button>
            {/* </PDFDownloadLink> */}
          </div>
          </form>
          </div>
        </div>
      </div>
      {modalOnDescargarProgramcionCirugia? <ModalConfirmarProgramacionCirugiasPDF setmodalOnDescargarProgramcionCirugia={setmodalOnDescargarProgramcionCirugia} dataProgramacionCirugia={dataProgramacionCirugia} fechaFinal={fechaFinal} fechaInicial={fechaInicial}/>:null}
    </div>
  );
};

export default ImprimirProgramacion;


const exportToExcell = (data) => {

  // Definir la cabecera
const header = [{
  NombreUsuario: 'Nombre Usuario',
  NumeroDocumento: 'Numero Documento',
  Edad: 'Edad',
  Sala: 'Sala',
  Cirugia: 'Cirugia',
  Fecha: 'Fecha',
  Telefono: 'Telefono',
  HoraInicial: 'Hora Inicial',
  HoraFinal: 'Hora Final',
  NombreEntidadAseguradora: 'Nombre Entidad Aseguradora',
  Estado: 'Estado',
  Cama: 'Cama',
  TipoAtencion: 'Tipo Atencion',
  Procedimiento: 'Procedimiento'
}];

// Crear los datos procesados sin push
const processedData = data.map(element => {
  // Crear el objeto principal con procedimientos concatenados
  return {
    NombreUsuario: element.MPNOMC,
    NumeroDocumento: element.MPCedu,
    Edad: calcularEdad(element.MPFchN ? element.MPFchN.split(' ') : null),
    Sala: element.ProNcons || '',
    Cirugia: element.ProCirCod,
    Fecha: element.ProFec,
    Telefono: element.MPTele,
    HoraInicial: element.ProHorI,
    HoraFinal: element.ProHorF,
    NombreEntidadAseguradora: element.ProNEPS,
    Estado: element.ProEsta === '6' ? 'Pendiente' :
      element.ProEsta === '3' ? 'Cancelado' :
      element.ProEsta === '5' ? 'Facturado' :
      element.ultimoEstado === 'reservado' ? 'Reservado' :
      element.ultimoEstado === 'confirmado' ? 'confirmado' :
      element.ultimoEstado === 'ingreso a sala' ? 'ingreso a sala' :
      element.ultimoEstado === 'preparado' ? 'preparado' :
      element.ultimoEstado === 'cirugia' ? 'cirugia' :
      element.ultimoEstado === 'salida' ? 'salida' : 
      element.ProEsta === '4' ? 'Realizado' :
      element.ultimoEstado === 'recuperacion' ? 'recuperacion' :           
      element.ProEsta === '1' ? 'Reservado' :
      element.ProEsta === '7' ? 'Reservado' :
      element.ProEsta === '2' ? 'confirmado' :
      element.ProEsta === '8' ? 'Pendiente' : null,
    Cama: element.TFcCodCam,
    TipoAtencion: element.ProSit === config.SELECT_PROGRAMADA ? 'PROGRAMADA' :
      element.ProSit === config.SELECT_URGENCIAS ? 'URGENCIAS' :
      element.ProSit === config.SELECT_AMBULATORIA ? 'AMBULATORIA' : null,
    Procedimiento: element.Procedimientos.map(procedi => procedi.CrgDes).join(', ')
  };
});

// Concatenar la cabecera con los datos procesados
const finalData = header.concat(processedData);

console.log(finalData);


  
 

  // Crear una hoja de trabajo usando objetos
  const ws = XLSX.utils.json_to_sheet(finalData, {skipHeader: true});

  // Ajustar el ancho de las columnas
  ws['!cols'] = [
      {wch: 40},
      {wch: 20},
      {wch: 7},
      {wch: 30},
      {wch: 10},
      {wch: 10},
      {wch: 10},
      {wch: 10},
      {wch: 10},
      {wch: 40},
      {wch: 10},
      {wch: 10},
      {wch: 12},
      {wch: 40},
  ];

  // Crear un nuevo libro de trabajo y agregar la hoja de trabajo
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "programacionCirugia");

  // Escribir el archivo Excel y desencadenar la descarga
  const exportFileName = "programacionCirugia.xlsx";
  XLSX.writeFile(wb, exportFileName);
};